function waitForElm(selectors) {
    return new Promise(resolve => {
        var k = 0;
        do {
            if (document.querySelector(selectors[k])) {
                selectors.splice(k, 1);
                k = -1;
            }

            k++;
        } while (k < selectors.length);

        if (selectors.length === 0) {
            return resolve();
        }

        const observer = new MutationObserver(mutations => {
            var i = 0;
            do {
                if (document.querySelector(selectors[i])) {
                    selectors.splice(i, 1);
                    i = i-1;
                }

                i++;
            } while (i < selectors.length);

            if (selectors.length === 0) {
                observer.disconnect();
                resolve();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

function clavToggleNode(mutation, node) {
    if (mutation.target.className.toString().includes('open') || mutation.target.className.toString().includes('sidebar--opened')) {
        node.style.opacity = 0;
    } else {
        node.style.opacity = 1;
    }
}

function initObserver(observerableNode, nodeToToggle) {
    waitForElm([observerableNode, nodeToToggle]).then(() => {
        function cartOpenCallback(mutationsList, observer) {
            mutationsList.forEach(mutation => {
                if (mutation.attributeName === 'class') {
                    clavToggleNode(mutation, document.querySelector(nodeToToggle));
                }
            })
        }

        const cartMutationObserver = new MutationObserver(cartOpenCallback);
        cartMutationObserver.observe(document.querySelector(observerableNode), { attributes: true });
    });
}

let slideCartNode = '.slidecarthq';
let slideCartNodeAlt = '#site-cart-sidebar';
let smileNode = '#smile-ui-lite-container'
let trustedShops = "[id^='trustbadge-container-']";
let dummyChatBotNode = '#dummy-chat-button-iframe';
let menuNode = '#site-menu-sidebar';

initObserver(slideCartNode, smileNode);
initObserver(slideCartNode, trustedShops);
initObserver(slideCartNode, dummyChatBotNode);
initObserver(slideCartNodeAlt, smileNode);
initObserver(slideCartNodeAlt, trustedShops);
initObserver(slideCartNodeAlt, dummyChatBotNode);
initObserver(menuNode, smileNode);
initObserver(menuNode, trustedShops);
initObserver(menuNode, dummyChatBotNode);
